import { pricingAPI } from '../services/pricingAPI';
import { useState } from 'react';
import { toast } from 'react-hot-toast';


export const useYapePayment = () => {
  const [showYapeModal, setShowYapeModal] = useState(false);
  const [yapePurchaseData, setYapePurchaseData] = useState(null);
  const [confirmationCode, setConfirmationCode] = useState('');
  const [receiptFile, setReceiptFile] = useState(null);
  const [submittingYape, setSubmittingYape] = useState(false);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validar que sea una imagen
      if (!file.type.startsWith('image/')) {
        toast.error('Por favor, selecciona una imagen válida');
        return;
      }
      
      // Validar tamaño (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('La imagen no debe superar los 5MB');
        return;
      }
      
      setReceiptFile(file);
    }
  };

  const initiateYapePayment = (purchaseData) => {
    setYapePurchaseData(purchaseData);
    setShowYapeModal(true);
  };

  const handleYapeSubmit = async (user) => {
    if (!confirmationCode && !receiptFile) {
      toast.error('Debes proporcionar el código de confirmación o subir una imagen del comprobante');
      return;
    }

    setSubmittingYape(true);
    try {
      const formData = new FormData();
      const yapeData = {
        documentCount: parseInt(yapePurchaseData.documentCount),
        totalAmount: parseFloat(yapePurchaseData.totalAmount),
        originalPrice: parseFloat(yapePurchaseData.originalPrice),
        discount: parseFloat(yapePurchaseData.discount || 0),
        discountPercent: parseFloat(yapePurchaseData.discountPercent || 0),
        confirmationCode: confirmationCode || "",
        userEmail: user?.email || '',
        userName: user?.full_name || user?.name || ''
      };
      
      // Validar que los datos requeridos estén presentes
      if (!yapeData.userEmail) {
        toast.error('Email del usuario requerido');
        return;
      }
      
      if (yapeData.documentCount <= 0) {
        toast.error('Cantidad de documentos debe ser mayor a 0');
        return;
      }
      
      formData.append('data', JSON.stringify(yapeData));
      if (receiptFile) {
        formData.append('receiptImage', receiptFile);
      }
      
      const result = await pricingAPI.sendYapePayment(formData);
      if (result.status === "ok") {
        toast.success('¡Comprobante enviado! Te notificaremos por correo cuando se apruebe tu compra.');
        setShowYapeModal(false);
        setConfirmationCode('');
        setReceiptFile(null);
        setYapePurchaseData(null);
      } else {
        toast.error(result.message || 'Error al enviar el comprobante. Inténtalo de nuevo.');
      }
    } catch (error) {
      let errorMessage = 'Error al enviar el comprobante. Inténtalo de nuevo.';
      
      if (error.response) {
        // Error de respuesta del servidor
        if (error.response.status === 401) {
          errorMessage = 'Sesión expirada. Por favor, inicia sesión nuevamente.';
          // Redirigir al login
          window.location.href = '/login';
          return;
        } else if (error.response.status === 403) {
          errorMessage = 'No tienes permisos para realizar esta acción.';
        } else if (error.response.status === 422) {
          errorMessage = 'Datos inválidos. Verifica que todos los campos estén correctos.';
        } else if (error.response.data?.detail) {
          if (Array.isArray(error.response.data.detail)) {
            errorMessage = error.response.data.detail.map(err => err.msg || err.message || err).join(', ');
          } else {
            errorMessage = error.response.data.detail;
          }
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        }
      } else if (error.request) {
        // Error de red
        errorMessage = 'Error de conexión. Verifica tu conexión a internet y que el servidor esté funcionando.';
      } else {
        // Otro tipo de error
        errorMessage = error.message || 'Error desconocido.';
      }
      
      toast.error(errorMessage);
    } finally {
      setSubmittingYape(false);
    }
  };

  const closeYapeModal = () => {
    setShowYapeModal(false);
    setConfirmationCode('');
    setReceiptFile(null);
    setYapePurchaseData(null);
  };

  return {
    showYapeModal,
    yapePurchaseData,
    confirmationCode,
    setConfirmationCode,
    receiptFile,
    submittingYape,
    handleFileUpload,
    initiateYapePayment,
    handleYapeSubmit,
    closeYapeModal
  };
};
